export const initRecurring = ({
  api, apiParams = [],
  isActivateStraightAway = false,
  initCb = () => {},
  endCb = () => {},
  successCb = () => {},
  recurringTimeIntervals = [5, 10]
}) => {
  initCb();
  let intervalIndex = 0;
  let isRecurrActive = false;
  let apiCallInProcess = false;

  const inactivateRecurring = () => {
    isRecurrActive = false;
  };

  const activateRecurring = () => {
    isRecurrActive = true;
    triggerAction();
  };

  const removeEventListeners = () => {
    inactivateRecurring();
    window.removeEventListener('focus', activateRecurring);
    window.removeEventListener('blur', inactivateRecurring);
  };

  const triggerAction = () => {
    if (intervalIndex < recurringTimeIntervals.length) {
      if (isRecurrActive && !apiCallInProcess) {
        const interval = recurringTimeIntervals[intervalIndex];
        apiCallInProcess = true;
        setTimeout(() => {
          api(...apiParams, (res) => {
            apiCallInProcess = false;
            intervalIndex += 1;
            if (res.errorRecurring) {
              triggerAction();
            } else {
              successCb(res);
              removeEventListeners();
            }
          });
        }, interval * 1000);
      }
    } else {
      endCb();
      removeEventListeners();
    }
  };

  if (isActivateStraightAway) {
    activateRecurring();
  }

  window.addEventListener('focus', activateRecurring);
  window.addEventListener('blur', inactivateRecurring);
};

export default initRecurring;



// WEBPACK FOOTER //
// ./src/libs/activate.js